export default "__VITE_ASSET__CYCDdiJI__"